module.exports = __webpack_public_path__ + "img/hoslogo3.1015640c.png";